import React from "react";
import styled from "styled-components";

const StyledInput = styled.input`
	flex: 1;
	background-color: transparent;
	border: none;
	color: white;
	font-size: 2rem;
	text-align: right;
	margin-right: 1rem;
	font-family: "Space Mono";

	&:focus {
		outline: none;
	}

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	-moz-appearance: textfield;
`;

type InputProps = {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	type?: string;
	disabled?: boolean;
};

export const Input: React.FC<InputProps> = ({
	value,
	onChange,
	placeholder = "0.0",
	type = "number",
	disabled,
	...props
}) => (
	<StyledInput
		type={type}
		value={value}
		onChange={(e) => onChange(e.target.value)}
		placeholder={placeholder}
		{...props}
	/>
);
